<template>
  <div class="article">
    <div class="article-main">
      <p>1、管理登录</p>
      <p>（1）使用主流浏览器打开网址www.itneituiquan.com，提供3种登录方式。</p>
      <img src="../../assets/images/message_1.png" />
      <p>（2）新用户可用使用手机号码注册。</p>
      <img src="../../assets/images/message_2.png" />
      <p>2、添加简历</p>
      <p>（1）上传简历并解析，可以解析Word或PDF格式的附件简历</p>
      <img src="../../assets/images/message_3.png" />
      <p>分步保存个人信息</p>
      <img src="../../assets/images/message_4.png" />
      <p>（2）创建在线简历，手动完善简历信息</p>
      <img src="../../assets/images/message_5.png" />
      <img src="../../assets/images/message_6.png" />
      <p>
        （2）上传附件简历：即可以用于完善在线简历，也可以直接添加附件简历快速投递。
        注：投递简历时，选择投递在线简历可以屏蔽部分个人信息，保护好候选人的隐私；附件简历目前做不到这一点。
      </p>
      <img src="../../assets/images/message_7.png" />
      <p>3、申请内推，投递简历</p>
      <p>（1）浏览主页，选择心仪岗位</p>
      <img src="../../assets/images/message_8.png" />
      <p>（2）申请内推时可以选择投递1.在线简历，2-附件简历（单选）</p>
      <img src="../../assets/images/message_9.png" />
      <p>（3）参加企业专场（专场是企业为求职者在周末时间举办的统一招聘活动）</p>
      <img src="../../assets/images/message_10.png" />
      <p>
        4、投递状态反馈（个人中心查看）<br />
        (1)待优化简历（如果你的简历为填写完善，内推圈组织者会提供专业的修改建议）<br />
        (2)已推荐（简历通过筛选，内推圈推送给企业，等待企业HR反馈）<br />
        (3)企业筛选通过（通过企业筛选，等待企业面试通知）<br />
        (4)企业筛选未通过
      </p>
      <img src="../../assets/images/message_11.png" />
    </div>
  </div>
</template>

<script>
export default {
  name: "message",
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
.article {
  width: 100%;
  padding: 20px 0;
  box-sizing: border-box;
  margin: auto;
  background: #fff;
  &-main {
    width: 1200px;
    margin: auto;
  }
  p {
    line-height: 30px;
    margin: 10px 0;
  }
  img {
    display: block;
    width: 100%;
  }
}
</style>
